<div class="rate" [class.row]="isCardView" [ngClass]="classStay" [hidden]="(survey.satisfaction.score<=0)">
  <div class="text-center" [ngClass]="{'col-2': isCardView}">
    <i [ngClass]="icon"></i>
  </div>
  <div [ngClass]="classText">{{('followup.summary.survey-comments.rate' | translate )}}</div>
  <div [ngClass]="{'col-5': isCardView, 'text-center': !isCardView}">
    <span class="scale">{{survey.satisfaction.score | formatScore:2}}| 5.0</span>
  </div>
</div>
